import { render, staticRenderFns } from "./FormUsersWorkspace.vue?vue&type=template&id=0f2d5764"
import script from "./FormUsersWorkspace.vue?vue&type=script&lang=js"
export * from "./FormUsersWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports